import { render } from "./AlertsCommentsDialog.vue?vue&type=template&id=f329e73e&scoped=true&ts=true"
import script from "./AlertsCommentsDialog.vue?vue&type=script&lang=ts"
export * from "./AlertsCommentsDialog.vue?vue&type=script&lang=ts"

import "./AlertsCommentsDialog.vue?vue&type=style&index=0&id=f329e73e&scoped=true&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f329e73e"]])

export default __exports__